import classNames from 'classnames';
import React from 'react';

import './styles.scss';

export const Spinner = ({fixed}) => <div className={classNames('spinner', {fixed})} />;
